module.exports = __webpack_public_path__ + "res/22-img_play_bg.d3b4987b73a34b9b5db3fb332edcd0dd.png";